import React from "react";
import { connect } from "react-redux";

import CountryCode from "@mapmycustomers/shared/enum/CountryCode";

import { getCountryCode } from "@app/scene/map/store/layers/boundaries/selectors";
import { RootState } from "@app/store/rootReducer";

import DemographyFeaturesLayer from "../../features/DemographyFeature/DemographyFeaturesLayer";

interface Props {
  countryCode: CountryCode;
}

const DemographyLayer: React.FC<Props> = ({ countryCode }) => {
  return <DemographyFeaturesLayer countryCode={countryCode} />;
};

const mapStateToProps = (state: RootState) => ({
  countryCode: getCountryCode(state),
});

export default connect(mapStateToProps)(DemographyLayer);
